module.exports = __webpack_public_path__ + "img/Desk Stationary A10.fd61d8a1.jpg";